<template>
	<b-card>
		<div slot="header">
			<b-row>
				<b-col class="pt-1" cols="3">
					<h5><b>История товара</b></h5>
				</b-col>
				<b-col cols="3">
					<b-form-group breakpoint="lg" label-size="sm" label-for="fromDate" class="required" size="sm">
						<date-picker class="s" style="width:100%;" v-model="startDate" lang="ru" :placeholder="$t('promo-to-product.start-date')" valueType="format" format="DD-MM-YYYY"/>
					</b-form-group>
				</b-col>
				<b-col cols="3">
					<b-form-group breakpoint="lg" label-size="sm" label-for="fromDate" class="required" size="sm">
						<date-picker class="s" style="width:100%;" v-model="endDate" lang="ru" :placeholder="$t('promo-to-product.finish-date')" valueType="format" format="DD-MM-YYYY"/>
					</b-form-group>
				</b-col>
				<b-col>
					<multiselect v-model="department" :options="departments" :show-labels="false" :multiple="true" :taggable="true" size="sm" track-by="id" label="name" :placeholder="$t('promo-to-product.department')"/>
				</b-col>
			</b-row>
		</div>
		<b-row class="mb-3">
			<b-col>
				<b-input-group size="sm">
					<b-input-group-prepend>
						<b-button disabled>{{ $t('goods.special-barcode') }}</b-button>
					</b-input-group-prepend>
					<b-input v-model="filter.barcode"/>
					<b-input-group-append>
						<b-button @click="filter.barcode = ''" class="fa fa-close text-danger"/>
					</b-input-group-append>
				</b-input-group>
			</b-col>
			<b-col>
				<b-input-group size="sm">
					<b-input-group-prepend>
						<b-button disabled>{{ $t('goods.name') }}</b-button>
					</b-input-group-prepend>
					<b-input v-model="filter.name"/>
					<b-input-group-append>
						<b-button @click="filter.name = ''" class="fa fa-close text-danger"/>
					</b-input-group-append>
				</b-input-group>
			</b-col>
			<b-col>
				<b-input-group size="sm">
					<b-input-group-prepend>
						<b-button disabled>{{ $t('goods.barcode') }}</b-button>
					</b-input-group-prepend>
					<b-input v-model="filter.multiBarcode" type="number"/>
					<b-input-group-append>
						<b-button @click="filter.multiBarcode = ''" class="fa fa-close text-danger"/>
					</b-input-group-append>
				</b-input-group>
			</b-col>
		</b-row>
		<b-table :items="items" :fields="columns" striped hover show-empty :busy="loading">
			<template slot="id" slot-scope="data">
				{{ paginate(data.index, payload.page, payload.limit) }}
			</template>
			<template slot="multiBarcodes" slot-scope="data">
				<div v-for="(barcode, index) in data.item.multiBarcodes" :key="`multi-${index}`">
					{{ barcode.barcode }}<br>
				</div>
			</template>
			<template slot="action" slot-scope="data">
				<b-badge @click="getHistoryItem(data.item.id)" pill variant="dark" class="cursor-pointer"><span style="font-size: 12px" class="fa fa-eye"/></b-badge>
			</template>
			<template slot="artikul" slot-scope="data">
				<div v-for="(tmp,index) in data.item.vendorCodes" :key="`qwe-${index}`">
					{{ tmp.vendor }}
				</div>
			</template>
		</b-table>
		<nav>
			<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page" align="center" aria-controls="table"/>
		</nav>

		<!--     View History Item     -->
		<b-modal v-model="viewHistory" size="xl" hide-footer>
			<template #modal-header>
				<b v-if="startDate!==''">{{ $t('promo-to-product.start-date') }} : </b> <span v-if="startDate!==''">{{ startDate }}</span>
				<b v-if="endDate!==''">{{ $t('promo-to-product.finish-date') }} : </b> <span v-if="endDate!==''">{{ endDate }}</span>
				<b>{{ $t('goods.special-barcode') }} : </b> <span>{{ historyItems.length > 0 ? historyItems[0].barcode : '' }}</span>
				<b>{{ $t('goods.name') }} : </b> <span>{{ historyItems.length > 0 ? historyItems[0].itemName : '' }}</span>
				<span @click="viewHistory = false" class="fa fa-close mt-1 cursor-pointer"/>
			</template>
			<b-table :items="historyItems" :fields="historyCols" striped hover show-empty>
				<template slot="id" slot-scope="data">
					{{ data.index+1 }}
				</template>
				<template slot="regNumber" slot-scope="data">
					{{ data.item.regNumber }}
<!--					<b v-if="data.item.regNumber.substring(0,4) === 'Разл'" @click="getConvertItem(data.item.docId)" class="ml-3 cursor-pointer"><i class="fa fa-eye"/></b>-->
				</template>
				<template slot="sum" slot-scope="data">
					{{ Math.abs(data.item.priceUzs*data.item.count) }}
				</template>
			</b-table>
		</b-modal>

		<!--     View Conversion Item     -->
		<b-modal v-model="convertView" size="xl" hide-footer>
			<b-row class="mt-3">
				<b-col>
					<table id="table" class="table-striped table-bordered table-hover" style="width: 100%">
						<thead>
						<tr>
							<th class="text-center">{{ '№' }}</th>
							<th class="text-center">{{ $t('goods.special-barcode') }}</th>
							<th class="text-center">{{ $t('goods.name') }}</th>
							<th class="text-center">{{ $t('incomes.create.price') }}</th>
							<th class="text-center">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center">{{ $t('warehouse.item.total') }}</th>
						</tr>
						</thead>
						<tbody v-for="(item, index) in convertItems" :key="`table-items-${index}`">
						<tr>
							<td class="text-center">{{ index+1 }}</td>
							<td class="text-center">{{ item.barcode }}</td>
							<td class="text-center">{{ item.name }}</td>
							<td class="text-center">€ {{ item.priceUzs }}</td>
							<td class="text-center">{{ item.amount }}</td>
							<td class="text-center">{{ (item.amount * item.count).toFixed(2) }}</td>
							<td class="text-center">
							<div v-for="(vendor, index) in item.vendorCodes" :key="`vendors-${index}`">
							{{ vendor.vendor }}
						 	</div>
								</td>
						</tr>
						</tbody>
						<tbody v-if="convertItems && convertItems.length === 0">
						<tr>
							<td colspan="6" class="text-center"><h4>{{ $t('empty') }}</h4></td>
						</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
		</b-modal>
	</b-card>
</template>

<script>
import RestaurantProductService from "../restaurant/service/product.service";
import HistoryService from "./history.service";
import Multiselect from 'vue-multiselect'
import UsersService from "../../services/users.sevice";
import WhDocument from "../../services/wh-document.service";

export default {
	name: "items-history",
	components: {Multiselect},
	data() {
		return {
			payload: {
				page: 1,
				limit: 20
			},
			filter: {
				barcode: '',
				name: '',
				multiBarcode: ''
			},
			startDate: '',
			endDate: '',
			historyItems: [],
			items: [],
			convertItems: [],
			total: null,
			loading: false,
			convertView: false,
			columns: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center', sortable: true},
				{key: 'name', label: this.$t('goods.name'), sortable: true},
				{key: 'multiBarcodes', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'artikul', label: this.$t('goods.artikul'), class: 'text-center'},
				{key: 'subCategoryName', label: 'Группа', class: 'text-center'},
				{key: 'sub2CategoryName', label: 'Категория', class: 'text-center'},
				{key: 'action', label: 'Действие', class: 'text-center'}
			],
			historyCols: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'regDate', label: this.$t('incomes.date'), class: 'text-center', sortable: true},
				{key: 'regNumber', label: this.$t('incomes.name'), sortable: true},
				{key: 'createdBy', label: 'Создано', class: 'text-center', sortable: true},
				{key: 'departmentName', label: this.$t('incomes.department'), class: 'text-center', sortable: true},
				{key: 'toDepartmentName', label: this.$t('incomes.toDepartment'), class: 'text-center', sortable: true},
				{key: 'contractorName', label: this.$t('contract.contragentName'), class: 'text-center', sortable: true},
				{key: 'incomeRegDate', label: 'Дата прих.', class: 'text-center', sortable: true},
				{key: 'count', label: this.$t('sale.kol-vo'), class: 'text-center'},
				{key: 'remaining', label: 'Oстатка', class: 'text-center'},
				{key: 'priceUzs', label: this.$t('incomes.create.price'), class: 'text-center'},
				{key: 'sum', label: 'Сумма', class: 'text-center'}
			],
			viewHistory: false,
			departments: [],
			depIds: [],
			department: null
		}
	},
	watch: {
		'payload.page': {
			handler(e) {
				this.getItems();
			}
		},
		'filter.barcode': {
			handler(e) {
				if (e.length > 3 || e === '')
					this.getItems();
			}
		},
		'filter.name': {
			handler(e) {
				if (e.length > 3 || e === '')
					this.getItems();
			}
		},
		'filter.multiBarcode': {
			handler(e) {
				if (e.length > 3 || e === '')
					this.getItems();
			}
		},
		'filter.artikul': {
			handler(e) {
				if (e.length > 3 || e === '')
					this.getItems();
			}
		},
		'department': {
			handler(d) {
				this.depIds = []
				d.forEach(i => {
					this.depIds.push(i.id)
				})
			}
		}
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		getItems() {
			let data = {categoryId: 14}
			if (this.filter.barcode.length > 0)
				data.barcode = this.filter.barcode
			if (this.filter.name.length > 0)
				data.name = this.filter.name
			if (this.filter.multiBarcode.length > 0)
				data.multiBarcode = this.filter.multiBarcode
			RestaurantProductService.getItems(this.payload, data).then(res => {
				this.items = res.data.items
				this.total = res.data.total
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getHistoryItem(itemId) {
			if (itemId) {
				this.loading = true
				HistoryService.getHistoryItem(itemId, {startDate: this.startDate, endDate: this.endDate, depIds: this.depIds}).then(res => {
					this.viewHistory = true
					this.historyItems = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		},
		getConvertItem(id) {
			WhDocument.get(id).then(res => {
				let tmp = false
				res.data.whItems.forEach(v => {
					if (v.documentId === id)
						tmp = true
				})
				if (tmp)
					this.convertItems = res.data.whItems
				else
					this.convertItems = res.data.whItems
				this.convertView = true
			})
		}
	},
	created() {
		UsersService.getPermittedDepartments().then(res => {
			this.departments = res.data.permittedDepartments
		})
		this.getItems();
	}
}
</script>

<style scoped>
.cursor-pointer:hover {
	cursor: pointer;
}
</style>
